import { render, staticRenderFns } from "./BoundedImage.vue?vue&type=template&id=6af17364"
import script from "./BoundedImage.vue?vue&type=script&lang=js"
export * from "./BoundedImage.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports